import React, {Fragment, useCallback, useContext, useState} from 'react';
import { useTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import InfoDescription from '../../components/InfoDescription';
import Price, { CURRENCY } from '../../components/Price';
import Table, {ALIGN_TABLE} from '../../components/Table';
import DateFormat from '../../components/DateFormat';
import Badge, {BADGE_TYPE} from "../../components/Badge";
import ReportFilterPaginate, {SHOW_MODE} from "../../components/ReportFilterPaginate";
import { UserContext } from '../../store/UserProvider';
import Modal from "../../components/Modal";
import API from "../../server/api";
import log from "../../utils/logger";
import {notify} from "../../components/Toast";
import {RepositoryContext} from "../../store/RepositoryProvider";

const MyCollections = () => {

    const {t} = useTranslation(['common', 'collection']);
    const userInfo = useContext(UserContext);

    const ORDER_STATUS = {
        paid: BADGE_TYPE.SUCCESS,
        awaiting_payment: BADGE_TYPE.WARN,
        cancelled: BADGE_TYPE.ERROR,
        completed: BADGE_TYPE.INFO,
        awaiting_assignment: BADGE_TYPE.INFO
    };

    const [showCollectionInfo, setShowCollectionInfo] = useState(false);
    const [collection, setCollection] = useState(null);

    const repository = useContext(RepositoryContext);

    const handleCloseCollectionInfo = useCallback(() => {
        setShowCollectionInfo(false);
        setCollection(null);
    }, []);

    const handleOpenCollectionInfo = useCallback((collection) => {
        repository.action(API.cashier.getCollection, {id: collection.id}).then((collection) => {
            setCollection(collection);
            setShowCollectionInfo(true);
        }).catch((e) => {
            log.error(e);
            notify.error(t('my_collection:error.not_load'));
        })
    }, []);

  return (
    <div className="trip-app">
      <NavBar title={(
        <>
          {t('my_collection:my_collections.title')}
        </>
      )} />
      <div className="trip-app-body">
          <ReportFilterPaginate
              apiHandler={(reportParams) => {
                  return userInfo.getMyCollections(reportParams);
              }}
              show={SHOW_MODE.ALWAYS}
              placeholder={t('sale:my_sales.filter')}
              output={(list) => (
                  <Table cols={2}>
                      {list.map((collection) => (
                          <Fragment key={collection.id}>
                              <Table.Row delim={true} className="pb-2" onClick={() => { handleOpenCollectionInfo(collection); }}>
                                  <div className="collection-row">
                                      <InfoDescription description={
                                          <>
                                              {t('my_collection:my_collections.collector')} {collection.collector?.profile?.fullName || '-'}
                                          </>
                                      }>
                                          <div className="collection-row_header">
                                              <DateFormat.DateTimeSmall date={collection.date} tz={true} />
                                              <div className="collection-row_badge">
                                                  {collection?.status === 'pending' && (
                                                      <Badge type={BADGE_TYPE.WARN}>
                                                          {t(`my_collection:my_collection_status.pending`)}
                                                      </Badge>
                                                  )}
                                                  {collection?.status === 'rejected' && (
                                                      <Badge type={BADGE_TYPE.ERROR}>
                                                          {t(`my_collection:my_collection_status.rejected`)}
                                                      </Badge>
                                                  )}
                                                  <Badge type={BADGE_TYPE.INFO}>
                                                      <Price currency={CURRENCY.RUB} value={collection.amount}/>
                                                  </Badge>
                                              </div>
                                          </div>
                                      </InfoDescription>
                                  </div>
                              </Table.Row>
                          </Fragment>
                      ))}
                  </Table>
              )}
              filters={[]}
          />
          <Modal show={collection && showCollectionInfo} onHide={handleCloseCollectionInfo}>
              <Modal.Header closeButton>
               <div className="d-flex gap-2 flex-column fs-6">
                   {t('my_collection:my_collection_info.title')}
                   {collection && (<DateFormat.DateTime date={collection.date} tz={true}/>)}
                   {collection?.status === 'pending' && (
                       <Badge type={BADGE_TYPE.WARN}>
                           {t(`my_collection:my_collection_status.pending`)}
                       </Badge>
                   )}
                   {collection?.status === 'rejected' && (
                       <Badge type={BADGE_TYPE.ERROR}>
                           {t(`my_collection:my_collection_status.rejected`)}
                       </Badge>
                   )}
               </div>
              </Modal.Header>
              <Modal.Body>
                  <div className="d-flex gap-1 flex-column mb-3">
                      <b>
                          {t('my_collection:my_collections.collector')} {collection?.collector?.profile?.fullName || '-'}
                      </b>
                      <b>
                          {t('my_collection:my_collections.amount')} <Price currency={CURRENCY.RUB} value={collection?.amount}/>
                      </b>
                  </div>


                  <Table cols={2} className="my-available-orders_table">
                      {collection?.orders?.map((order) => (
                          <Fragment key={order._id}>
                              <>
                                  <Table.Row>
                                      <Table.Cell>
                                          <div className="d-flex flex-column gap-1">
                                              <div className="d-flex gap-1">
                                                  {t('sale:my_sales.order', { order: order?.order?.codeNumber })}
                                                  <Badge type={ORDER_STATUS[order?.order?.status]}>{t(`sale:status.${order.order.status}`)}</Badge>
                                              </div>
                                              {t('sale:my_sales.from_date')}
                                              <DateFormat.DateTimeSmall date={order?.order?.date} tz={true} />
                                          </div>
                                      </Table.Cell>
                                      <Table.Cell align={ALIGN_TABLE.RIGHT}>
                                          <Badge type={BADGE_TYPE.INFO}>
                                              <Price currency={CURRENCY.RUB} value={order?.amount}/>
                                          </Badge>
                                      </Table.Cell>
                                  </Table.Row>
                                  {order?.amount > order?.order?.paymentDetails?.partialValue - (order?.order?.paymentDetails?.refundAmount || 0) && (
                                      <Table.Row>
                                          <Table.Cell colspan={2}>
                                              <div className={"bg-warning-subtle p-2"}>
                                                  <b>
                                                      {t('my_collection:error.incorrect_amount_title')}
                                                  </b>
                                                  <div>
                                                      {t('my_collection:error.incorrect_amount_desc')}
                                                  </div>
                                              </div>
                                          </Table.Cell>
                                      </Table.Row>
                                  )}
                                  <Table.Row delim={true} className="mb-1" />
                              </>
                          </Fragment>
                      ))}
                  </Table>
              </Modal.Body>
          </Modal>
      </div>
    </div>
  )
}

export default MyCollections;